import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export type EbookProps = {
  _id: string;
  id: string;
  title: string;
  author: string;
  description: string;
  cover: string;
  price: number;
  pageCount: number;
  category: string;
  language: string;
  active: boolean;
  status: boolean;
  createdAt?: string;
};

const EbookCard = (props: EbookProps) => {
  const { t } = useTranslation();
  const { _id, id, title, author, cover, price, pageCount, category } = props;
  const ebookId = id || _id;

  return (
    <Link to={`/ebook/${ebookId}`} className="group block">
      <div className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden hover:-translate-y-1">
        <div className="relative aspect-[3/4] overflow-hidden bg-neutral-100">
          <img
            src={cover}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {category && (
            <div className="absolute top-3 left-3">
              <span className="inline-flex items-center rounded-full bg-white/90 backdrop-blur-sm px-3 py-1 text-xs font-semibold text-neutral-700">
                {category}
              </span>
            </div>
          )}
        </div>
        <div className="p-4">
          <h3 className="font-bold text-neutral-900 text-base line-clamp-2 mb-1 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
          <p className="text-sm text-neutral-500 mb-2">{author}</p>
          <div className="flex items-center justify-between">
            <span className="text-lg font-extrabold bg-gradient-to-r from-primary-600 to-secondary-500 bg-clip-text text-transparent">
              ₮{price?.toLocaleString()}
            </span>
            {pageCount > 0 && (
              <span className="text-xs text-neutral-400">{pageCount} {t('ebook.pages')}</span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default EbookCard;
